module.exports = kolibriGlobal.lib.vuex;